import React from "react";
import { Box, keyframes } from "@chakra-ui/react";
const spin = keyframes `
  0% {
    transform: rotate(0deg)
  }

  100% {
    transform: rotate(360deg)
  }
`;
const elastic = keyframes `
  0% { 
    stroke-dashoffset: 380;
  }

  50% {
    stroke-dashoffset: 215;
  }

  100% {
    stroke-dashoffset: 380;
  }
`;
export function Spinner(props) {
    return (React.createElement(Box, { as: "svg", viewBox: "0 0 100 100", boxSize: 6, animation: `${spin} 650ms linear infinite`, ...props },
        React.createElement(Box, { as: "circle", fill: "none", stroke: "gray.300", strokeWidth: "14", cx: "50", cy: "50", r: "43" }),
        React.createElement(Box, { as: "circle", fill: "none", stroke: "forest", strokeWidth: "14", strokeLinecap: "butt", strokeDasharray: "430", strokeDashoffset: "360", cx: "50", cy: "50", r: "43", animation: `${elastic} 2s ease-in-out infinite` })));
}
